module.exports = __webpack_public_path__ + "media/images/prijava_pogledana-f35e5e47.svg";